module.exports = __webpack_public_path__ + "img/products_big_can_original.c6c466cf.png";